import { VoyageFilterType, VoyageFilterResult, FilterType } from "./types";

export class FilterUtils {
    static filterToString(filter: VoyageFilterType): string {
        const res = [];

        if (filter) {
            if (filter.commands && filter.commands.length) {
                filter.commands.forEach(item => {
                    if (item.vals?.length) {
                        res.push(`${item.not ? '!' : ''}${item.cmd}:${item.vals?.join('+')
                        }`);
                    }
                });
            }
            if (filter.text && filter.text.length) {
                res.push(...filter.text);
            }
        }

        return res.join(' ');
    }

    static stringToFilter(str: string): VoyageFilterType | undefined {
        if (!str.length) {
            return;
        }

        // Do 'omnibox' filtering. Each string token can be part of any search criteria (e.g. IMO, name, class)
        const tmpfilters = str.toLowerCase().split(' ').filter(s => !!s.length);

        const result: VoyageFilterType = {
            commands: [],
            text: [],
        };

        // Handle 'command' filters first [EXPERIMENTAL - should be optimised]
        for (let i = tmpfilters.length - 1; i >= 0; i--) {
            const filter = tmpfilters[i];

            if (filter == FilterType.ImoGrouping) {
                let storedImoNumbers = localStorage.getItem('imoGroup') || "[]";
                const vals = storedImoNumbers.split('+');
                const res: VoyageFilterResult = {};
                res.cmd = filter;
                res.vals = vals;
                result.commands.push(res);
            }

            if (filter.includes(':')) {
                // Remove from later filtering
                tmpfilters.splice(i, 1);

                const cmdval = filter.split(':');

                if (cmdval.length === 2 && cmdval[1].length) {
                    const res: VoyageFilterResult = {};

                    let cmd = cmdval[0];
                    const vals = cmdval[1].split('+');
                    if (cmd.startsWith('!')) {
                        res.not = true;
                        cmd = cmd.substring(1);
                    }
                    res.cmd = cmd;
                    res.vals = vals;

                    result.commands.push(res);
                }
            }
        }

        // Reverse for correct order
        result.commands = result.commands.reverse();

        result.text = tmpfilters;
        return result;
    }

}
